import {useEffect, useState} from "react";

export type ActiveIdType = string | null;

// More on options used by IntersectionObserver https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
interface IObserverOptions {
    root?: null | HTMLElement;
    rootMargin?: string;
    threshold?: number | number[];
}

export const useActiveElementId = (itemIds = [] as string[], options = {} as IObserverOptions): ActiveIdType => {
    const [activeId, setActiveId] = useState<ActiveIdType>(null);

    useEffect(() => {
        if (!("IntersectionObserver" in window)) {
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActiveId(entry.target.id);
                }
            });
        }, options);
        const elements: HTMLElement[] = [];

        itemIds.forEach((id) => {
            const element = document.getElementById(id);
            if (element) {
                observer.observe(element);
                elements.push(element);
            }
        });
        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, [itemIds]);

    return activeId;
};
